var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionUserAccountDelete({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1c5.035 0 9.276 3.384 10.582 8H11v13.952C5.394 22.447 1 17.738 1 12 1 5.925 5.925 1 12 1Z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 13H23v2h-1v7a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-7h-1v-2h2.5l.5-2h4l.5 2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.935a7.978 7.978 0 0 1-4.814-2.444A3.977 3.977 0 0 1 8.5 15a8.881 8.881 0 0 1 2.5-.66v5.595Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6a3 3 0 0 1 3 3h-4v2.825A2.998 2.998 0 0 1 12 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionUserAccountDelete);
export default __webpack_public_path__ + "static/media/ic_action_user_account_delete.0557b6786c2df31603b9bd2a546eb6ab.svg";
export { ForwardRef as ReactComponent };